import React from 'react';
import { Box } from '@material-ui/core';

import { PlayerPageCard } from './player-page-card.component';
import { AccessLinkRejected } from '../../_core/AccessLinkRejected/access-link-rejected.component';
import { AuthFailureReason } from '../../../lib/types/auth-failure.types';

interface IPublicEditPlayerUnauthorizedProps {
  reason: AuthFailureReason;
  signInPath: string;
}

// The player page's card chrome around a rejected email/text link.
export const PublicEditPlayerUnauthorized: React.FC<IPublicEditPlayerUnauthorizedProps> = ({ reason, signInPath }) => (
  <PlayerPageCard padding="32px 28px" centered>
    <Box style={{ height: 4, background: '#ef4444', borderRadius: 2, marginBottom: 24 }} />
    <AccessLinkRejected reason={reason} signInPath={signInPath} />
  </PlayerPageCard>
);
